module.exports = __webpack_public_path__ + "img/logo_davidoff_b@3x.8ff1cdb4.png";